
;"use strict";

var State = {

// Глобальные флаги тестовой модификации

	flTrace: 0, // Флаг включения трассировки

/////////////////////////////////////////

	dbVersion: 2, // версия хранилища в local storage

	super: 1072427180, // пароль суперпользователя

	startEvent: 'mousedown',
	currPage: 0,
	flSelection: 0,
	flModal: 0,
	flIpad: 0,
	flAnimate: 0,
	regionDataInit: 0, // Индикатор первой инициализации выбранного региона
	currRegname: '',
	currRegNum: 0,

	dsList: [
		'ds19.063',
		'ds19.064',
		'ds19.065',
		'ds19.066',
		'ds19.067',
		'ds19.068',
		'ds19.069',
		'ds19.070',
		'ds19.071',
		'ds19.072',
		'ds19.073',
		'ds19.074',
		'ds19.075',
		'ds19.076',
		'ds19.077',
		'ds19.078',

		'ds19.080',
		'ds19.081',
		'ds19.082',
		'ds19.083',
		'ds19.084',
		'ds19.085',
		'ds19.086',
		'ds19.087',
		'ds19.088',
		'ds19.089',
		'ds19.090',
		'ds19.091',
		'ds19.092',
		'ds19.093',
		'ds19.094',
		'ds19.095',
		'ds19.096'
	],

	stList: [
		'st19.090',
		'st19.091',
		'st19.092',
		'st19.093',
		'st19.094',
		'st19.095',
		'st19.096',
		'st19.097',
		'st19.098',
		'st19.099',
		'st19.100',
		'st19.101',
		'st19.102',

		'st19.105',
		'st19.106',
		'st19.107',
		'st19.108',
		'st19.109',
		'st19.110',
		'st19.111',
		'st19.112',
		'st19.113',
		'st19.114',
		'st19.115',
		'st19.116',
		'st19.117',
		'st19.118',
		'st19.119',
		'st19.120',
		'st19.121'
	],


	dsBuf: {
		'ds19.063': 0,
		'ds19.064': 0,
		'ds19.065': 0,
		'ds19.066': 0,
		'ds19.067': 0,
		'ds19.068': 0,
		'ds19.069': 0,
		'ds19.070': 0,
		'ds19.071': 0,
		'ds19.072': 0,
		'ds19.073': 0,
		'ds19.074': 0,
		'ds19.075': 0,
		'ds19.076': 0,
		'ds19.077': 0,
		'ds19.078': 0,

		'ds19.080': 0,
		'ds19.081': 0,
		'ds19.082': 0,
		'ds19.083': 0,
		'ds19.084': 0,
		'ds19.085': 0,
		'ds19.086': 0,
		'ds19.087': 0,
		'ds19.088': 0,
		'ds19.089': 0,
		'ds19.090': 0,
		'ds19.091': 0,
		'ds19.092': 0,
		'ds19.093': 0,
		'ds19.094': 0,
		'ds19.095': 0,
		'ds19.096': 0
	},

	stBuf: {
		'st19.090': 0,
		'st19.091': 0,
		'st19.092': 0,
		'st19.093': 0,
		'st19.094': 0,
		'st19.095': 0,
		'st19.096': 0,
		'st19.097': 0,
		'st19.098': 0,
		'st19.099': 0,
		'st19.100': 0,
		'st19.101': 0,
		'st19.102': 0,

		'st19.105': 0,
		'st19.106': 0,
		'st19.107': 0,
		'st19.108': 0,
		'st19.109': 0,
		'st19.110': 0,
		'st19.111': 0,
		'st19.112': 0,
		'st19.113': 0,
		'st19.114': 0,
		'st19.115': 0,
		'st19.116': 0,
		'st19.117': 0,
		'st19.118': 0,
		'st19.119': 0,
		'st19.120': 0,
		'st19.121': 0
	}
}

export default State;